var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "Task-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 100,
            model: _vm.edit,
            elem: _vm.taskDetailElem,
            rules: _vm.taskDetailRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "10" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: { label: "体检任务", prop: "taskId" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input-disabled",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "体检任务",
                                        clearable: "",
                                        filterable: "",
                                        size: "small",
                                        transfer: "true",
                                        "popper-append-to-body": false,
                                        disabled: _vm.disabled,
                                      },
                                      on: { change: _vm.changeTask },
                                      model: {
                                        value: _vm.edit.taskId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "taskId",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "edit.taskId",
                                      },
                                    },
                                    _vm._l(_vm.taskList, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        staticStyle: {
                                          width: "100%",
                                          "z-index": "9999",
                                        },
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleTaskChange(item)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: { label: "体检人群", prop: "crowdId" },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { multiple: true, disabled: true },
                                      model: {
                                        value: _vm.edit.crowdId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "crowdId", $$v)
                                        },
                                        expression: "edit.crowdId",
                                      },
                                    },
                                    _vm._l(_vm.crowdList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.value,
                                          attrs: { value: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "姓名", prop: "name" } },
                                [
                                  _c("el-autocomplete", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-key": "name",
                                      size: "mini",
                                      clearable: "",
                                      placeholder: "请输入关键词",
                                      "trigger-on-focus": false,
                                      "hide-loading": false,
                                      "highlight-first-item": true,
                                      "fetch-suggestions": (query, cb) => {
                                        _vm.queryStudent(query, cb)
                                      },
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      select: (rowData) => {
                                        _vm.selectStudent(rowData)
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "autocomplete-item",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "alias-text" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.name +
                                                          "(" +
                                                          item.idCard +
                                                          ")"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.edit.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "name", $$v)
                                      },
                                      expression: "edit.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "证件类型",
                                    prop: "idCardType",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      on: { "on-change": _vm.changeIdCardType },
                                      model: {
                                        value: _vm.edit.idCardType,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "idCardType", $$v)
                                        },
                                        expression: "edit.idCardType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.idCardTypes,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.value,
                                            attrs: { value: item.value },
                                          },
                                          [_vm._v(_vm._s(item.label))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "证件号码",
                                    prop: "idCard",
                                    required:
                                      _vm.edit.idCardType === 2 ? false : true,
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入证件号码",
                                      maxlength: "20",
                                      disabled:
                                        _vm.disabled ||
                                        _vm.edit.idCardType === 2,
                                    },
                                    on: { "on-change": _vm.cardchange },
                                    model: {
                                      value: _vm.edit.idCard,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "idCard", $$v)
                                      },
                                      expression: "edit.idCard",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "性别", prop: "gender" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.edit.gender,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "gender", $$v)
                                        },
                                        expression: "edit.gender",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.genderList,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.code,
                                            attrs: { value: item.code },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "出生日期",
                                    prop: "birthday",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.edit.birthday,
                                      editable: false,
                                      disabled: _vm.disabled,
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      placeholder: "出生日期",
                                    },
                                    on: { "on-change": _vm.changeBirthday },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "学校名称",
                                    prop: "schoolId",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.edit.schoolId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "schoolId", $$v)
                                        },
                                        expression: "edit.schoolId",
                                      },
                                    },
                                    _vm._l(_vm.schoolsList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.value,
                                          attrs: { value: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "年级", prop: "gradeId" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "年级",
                                        clearable: "",
                                        filterable: "",
                                        size: "small",
                                        transfer: "true",
                                        "popper-append-to-body": false,
                                        disabled: _vm.disabled,
                                      },
                                      on: { change: _vm.changeGrade },
                                      model: {
                                        value: _vm.edit.gradeId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "gradeId",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "edit.gradeId",
                                      },
                                    },
                                    _vm._l(_vm.gradesList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        staticStyle: {
                                          width: "100%",
                                          "z-index": "9999",
                                        },
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleGradeChange(item)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "班级", prop: "classesId" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "班级",
                                        clearable: "",
                                        filterable: "",
                                        size: "small",
                                        transfer: "true",
                                        "popper-append-to-body": false,
                                        disabled: _vm.disabled,
                                      },
                                      model: {
                                        value: _vm.edit.classesId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "classesId",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "edit.classesId",
                                      },
                                    },
                                    _vm._l(_vm.classList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        staticStyle: {
                                          width: "100%",
                                          "z-index": "9999",
                                        },
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleClassChange(item)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "民族", prop: "nationsId" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.edit.nationsId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "nationsId", $$v)
                                        },
                                        expression: "edit.nationsId",
                                      },
                                    },
                                    _vm._l(_vm.nationsList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.value,
                                          attrs: { value: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "手机号码", prop: "phone" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入手机号码",
                                      maxlength: "11",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value: _vm.edit.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "phone", $$v)
                                      },
                                      expression: "edit.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "固定电话", prop: "phone" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "tel",
                                      placeholder: "请输入固定电话",
                                      disabled: _vm.disabled,
                                      maxlength: "15",
                                    },
                                    model: {
                                      value: _vm.edit.telPhone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "telPhone", $$v)
                                      },
                                      expression: "edit.telPhone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "现住址",
                                    prop: "currentAddress",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入现住址",
                                      disabled: _vm.disabled,
                                      maxlength: "125",
                                    },
                                    model: {
                                      value: _vm.edit.currentAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.edit,
                                          "currentAddress",
                                          $$v
                                        )
                                      },
                                      expression: "edit.currentAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "户籍地", prop: "address" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入户籍地",
                                      disabled: _vm.disabled,
                                      maxlength: "125",
                                    },
                                    model: {
                                      value: _vm.edit.address,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "address", $$v)
                                      },
                                      expression: "edit.address",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "来市时间",
                                    prop: "arrivalDate",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.edit.arrivalDate,
                                      editable: false,
                                      disabled: _vm.disabled,
                                      type: "month",
                                      format: "yyyy-MM",
                                      placeholder: "来市时间",
                                    },
                                    on: { "on-change": _vm.changeArrivalDate },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "居住类型",
                                    prop: "resideCondition",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.edit.resideCondition,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "resideCondition",
                                            $$v
                                          )
                                        },
                                        expression: "edit.resideCondition",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.resideConditionList,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.code,
                                            attrs: { value: item.code },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "入户情况",
                                    prop: "occupancyType",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.edit.occupancyType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "occupancyType",
                                            $$v
                                          )
                                        },
                                        expression: "edit.occupancyType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.occupancyTypeList,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.code,
                                            attrs: { value: item.code },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "入户时间",
                                    prop: "occupancyDate",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.edit.occupancyDate,
                                      editable: false,
                                      disabled: _vm.disabled,
                                      type: "month",
                                      format: "yyyy-MM",
                                      placeholder: "入户时间",
                                    },
                                    on: {
                                      "on-change": _vm.changeOccupancyDate,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "入学时间",
                                    prop: "entryDate",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.edit.entryDate,
                                      editable: false,
                                      disabled: _vm.disabled,
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      placeholder: "入学时间",
                                    },
                                    on: { "on-change": _vm.changeEntryDate },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "居住类型",
                                    prop: "resideType",
                                  },
                                },
                                [
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.edit.resideType,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "resideType", $$v)
                                        },
                                        expression: "edit.resideType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.resideTypeList,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.code,
                                            attrs: { value: item.code },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "既往病史",
                                    prop: "pastMedicalHistorys",
                                  },
                                },
                                [
                                  _c(
                                    "MyCheckBox",
                                    {
                                      attrs: {
                                        enumList:
                                          _vm.enums.pastMedicalHistoryList,
                                        "ignore-list": ["1"],
                                        dataList: _vm.pastMedicalHistorys,
                                        dataStr: _vm.edit.pastMedicalHistory,
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        "update:dataList": function ($event) {
                                          _vm.pastMedicalHistorys = $event
                                        },
                                        "update:data-list": function ($event) {
                                          _vm.pastMedicalHistorys = $event
                                        },
                                        "update:dataStr": function ($event) {
                                          return _vm.$set(
                                            _vm.edit,
                                            "pastMedicalHistory",
                                            $event
                                          )
                                        },
                                        "update:data-str": function ($event) {
                                          return _vm.$set(
                                            _vm.edit,
                                            "pastMedicalHistory",
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.edit.pastMedicalHistory.indexOf(
                                        "7"
                                      ) !== -1
                                        ? _c("Input", {
                                            attrs: { placeholder: "请输入" },
                                            model: {
                                              value:
                                                _vm.edit
                                                  .pastMedicalHistoryOther,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "pastMedicalHistoryOther",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "edit.pastMedicalHistoryOther",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "过敏史",
                                    prop: "allergyHistory",
                                  },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.edit.allergyHistory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "allergyHistory",
                                            $$v
                                          )
                                        },
                                        expression: "edit.allergyHistory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.allergyHistoryList,
                                      function (item) {
                                        return _c(
                                          "Radio",
                                          {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              disabled: _vm.disabled,
                                            },
                                            nativeOn: {
                                              dblclick: function ($event) {
                                                $event.preventDefault()
                                                return (() => {
                                                  _vm.form.other = null
                                                }).apply(null, arguments)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.value))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _vm.edit.allergyHistory === 2
                                ? _c("Input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value: _vm.edit.allergyHistoryOther,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.edit,
                                          "allergyHistoryOther",
                                          $$v
                                        )
                                      },
                                      expression: "edit.allergyHistoryOther",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { span: "8" },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "传染病接触史",
                                    prop: "infectionHistory",
                                  },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.edit.infectionHistory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "infectionHistory",
                                            $$v
                                          )
                                        },
                                        expression: "edit.infectionHistory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.enums.infectionHistoryList,
                                      function (item) {
                                        return _c(
                                          "Radio",
                                          {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              disabled: _vm.disabled,
                                            },
                                            nativeOn: {
                                              dblclick: function ($event) {
                                                $event.preventDefault()
                                                return (() => {
                                                  _vm.form.other = null
                                                }).apply(null, arguments)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.value))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { span: "12" },
                            },
                            [
                              _vm.edit.infectionHistory === 2
                                ? _c("Input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value: _vm.edit.infectionHistoryOther,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.edit,
                                          "infectionHistoryOther",
                                          $$v
                                        )
                                      },
                                      expression: "edit.infectionHistoryOther",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c("Col", { attrs: { span: "24" } }, [
                            _c(
                              "button",
                              {
                                staticClass: "ivu-btn ivu-btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addFamilyMembers(1)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v("新增亲属"),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.familyMembers && _vm.familyMembers.length > 0
                        ? _c(
                            "Row",
                            [
                              _c(
                                "Col",
                                [
                                  _c(
                                    "vxe-table",
                                    {
                                      ref: "familyMember",
                                      staticClass: "mytable-scrollbar",
                                      staticStyle: { "margin-top": "10px" },
                                      attrs: {
                                        border: "",
                                        "row-config": {
                                          isCurrent: true,
                                          isHover: true,
                                        },
                                        "custom-config": {
                                          storage: true,
                                          visible: true,
                                        },
                                        data: _vm.familyMembers,
                                        "sort-config": { trigger: "cell" },
                                      },
                                    },
                                    [
                                      _vm._l(_vm.columns, function (item) {
                                        return _c("vxe-column", {
                                          attrs: {
                                            field: item.key,
                                            title: item.title,
                                            visible: item.visible,
                                            formatter: item.formatter
                                              ? item.formatter
                                              : "",
                                            fixed: item.fixed ? item.fixed : "",
                                            width: item.width,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row }) {
                                                  return [
                                                    item.key == "type"
                                                      ? _c(
                                                          "Select",
                                                          {
                                                            staticStyle: {
                                                              "z-index": "9999",
                                                            },
                                                            attrs: {
                                                              placement: "top",
                                                              transfer: "",
                                                            },
                                                            model: {
                                                              value:
                                                                row[item.key],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    row,
                                                                    item.key,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "row[item.key]",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.enums
                                                              .familyMemberTypeList,
                                                            function (item) {
                                                              return _c(
                                                                "Option",
                                                                {
                                                                  key: item.code,
                                                                  staticStyle: {
                                                                    "z-index":
                                                                      "9999",
                                                                  },
                                                                  attrs: {
                                                                    value:
                                                                      item.code,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.value
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : item.key.indexOf(
                                                          "idcardType"
                                                        ) !== -1
                                                      ? _c(
                                                          "Select",
                                                          {
                                                            attrs: {
                                                              placement: "top",
                                                              transfer: "",
                                                            },
                                                            model: {
                                                              value:
                                                                row[item.key],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    row,
                                                                    item.key,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "row[item.key]",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.enums
                                                              .idCardTypes,
                                                            function (item) {
                                                              return _c(
                                                                "Option",
                                                                {
                                                                  key: item.value,
                                                                  attrs: {
                                                                    value:
                                                                      item.value,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.label
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : item.key == "idcard"
                                                      ? _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入身份证",
                                                            maxlength: "18",
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.idcardInput(
                                                                row
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              row[item.key],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row,
                                                                item.key,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row[item.key]",
                                                          },
                                                        })
                                                      : item.key.indexOf(
                                                          "gender"
                                                        ) !== -1
                                                      ? _c(
                                                          "Select",
                                                          {
                                                            attrs: {
                                                              placement: "top",
                                                              transfer: "",
                                                            },
                                                            model: {
                                                              value:
                                                                row[item.key],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    row,
                                                                    item.key,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "row[item.key]",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.enums
                                                              .genderList,
                                                            function (item) {
                                                              return _c(
                                                                "Option",
                                                                {
                                                                  key: item.code,
                                                                  attrs: {
                                                                    value:
                                                                      item.code,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : item.key.indexOf(
                                                          "birthday"
                                                        ) !== -1
                                                      ? _c("DatePicker", {
                                                          attrs: {
                                                            value:
                                                              row[item.key],
                                                            editable: false,
                                                            type: "date",
                                                            format:
                                                              "yyyy-MM-dd",
                                                            placeholder:
                                                              "出生日期",
                                                            placement: "top",
                                                            transfer: "",
                                                          },
                                                          on: {
                                                            "on-change": (
                                                              val
                                                            ) => {
                                                              row.birthday = val
                                                            },
                                                          },
                                                        })
                                                      : _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            maxlength: "125",
                                                            size: "mini",
                                                          },
                                                          model: {
                                                            value:
                                                              row[item.key],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row,
                                                                item.key,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row[item.key]",
                                                          },
                                                        }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      }),
                                      _c("vxe-column", {
                                        attrs: {
                                          title: "操作",
                                          width: "180",
                                          "show-overflow": "",
                                          fixed: "right",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c(
                                                    "vxe-button",
                                                    {
                                                      staticClass: "txtBlue",
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addFamilyMembers(
                                                            -1,
                                                            row.rowId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("删除")]
                                                  ),
                                                  _vm._v(
                                                    "\n                     | \n                    "
                                                  ),
                                                  row.status == 2
                                                    ? _c("span", [
                                                        _vm._v("默认家属"),
                                                      ])
                                                    : _vm._e(),
                                                  row.status == 1
                                                    ? _c(
                                                        "vxe-button",
                                                        {
                                                          staticClass:
                                                            "txtBlue",
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.setDefault(
                                                                row.rowId
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("设为默认家属")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3964099835
                                        ),
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "14" } },
                    [
                      _c("TaskDetailTemplate", {
                        ref: "taskTemplate",
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          packagesNames: _vm.packagesNameList,
                          taskProject: _vm.taskProjects,
                          packageDisabled: _vm.packageDisabled,
                          itemDisabled: _vm.itemDisabled,
                          physicalType: _vm.edit.type,
                          bloodTubeRemark: _vm.edit.bloodTubeRemark,
                        },
                        on: {
                          "update:physicalType": function ($event) {
                            return _vm.$set(_vm.edit, "type", $event)
                          },
                          "update:physical-type": function ($event) {
                            return _vm.$set(_vm.edit, "type", $event)
                          },
                          "update:bloodTubeRemark": function ($event) {
                            return _vm.$set(_vm.edit, "bloodTubeRemark", $event)
                          },
                          "update:blood-tube-remark": function ($event) {
                            return _vm.$set(_vm.edit, "bloodTubeRemark", $event)
                          },
                          setPhysicalType: _vm.setPhysicalType,
                          setPackageId: _vm.setPackageId,
                          setBloodTubeCount: _vm.setBloodTubeCount,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }